import PropTypes from "prop-types";
import React from "react";

import Tooltip from "../../shared/components/Tooltip";
import { ServiceShape } from "../proptypes";

export const getServiceTooltip = service => {
  let message;

  if (service.pending) {
    message =
      "Service not connected to RBAC yet, follow instructions on the Service page to complete configuration.";
  } else if (!service.last_contact) {
    message = "Service is ready, but has not been contacted yet.";
  } else if (service.last_contact && service.last_contact.$date) {
    const now = Date.now();
    if ((now - service.last_contact.$date) / 3600000 > 2) {
      message = "Service has not been active for over 2 hours.";
    }
  }

  if (message) {
    return (
      <Tooltip
        position="btm-left"
        message={message}
        style={{ width: "310px", whiteSpace: "normal", marginLeft: "-1rem" }}
      >
        <i className="p-icon--pending" />
      </Tooltip>
    );
  }
  return undefined;
};

const ServicesListItem = ({ service, onServiceClicked, selected }) => (
  <li className="p-list__item">
    <div
      className={`p-button--list p-second-level l-flex-spaced-centered ${
        selected ? "is-selected" : ""
      }`}
      role="button"
      tabIndex={0}
      onClick={() => onServiceClicked(service.$uri)}
      onKeyPress={() => onServiceClicked(service.$uri)}
    >
      {service.name}
      {getServiceTooltip(service)}
    </div>
  </li>
);

ServicesListItem.propTypes = {
  service: ServiceShape.isRequired,
  onServiceClicked: PropTypes.func.isRequired,
  selected: PropTypes.bool
};

ServicesListItem.defaultProps = {
  selected: false
};

export default ServicesListItem;
